import { render, staticRenderFns } from "./ResizeCol.vue?vue&type=template&id=4a3c5cc8"
import script from "./ResizeCol.vue?vue&type=script&lang=js"
export * from "./ResizeCol.vue?vue&type=script&lang=js"
import style0 from "./ResizeCol.vue?vue&type=style&index=0&id=4a3c5cc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports